import React from 'react';
import { Text, Image, Button } from 'components/ui';
import ApplePay from 'services/ApplePay';
import LanguageLocale from 'utils/LanguageLocale';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';
import EN from 'components/ApplePayButton/locales/ApplePayButton_en_US.js';
import FR from 'components/ApplePayButton/locales/ApplePayButton_fr_CA.js';

//Analytics
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import * as pdpAnalytics from 'analytics/productPage/pdpAnalytics';

const { getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(EN, FR);

const iconOnlySize = {
    src: '/img/ufe/rwd-basket/apple-pay-logo.svg',
    width: 59,
    height: 'auto'
};

const iconOnlyDisabledSrc = '/img/ufe/rwd-basket/apple-pay-logo-gray.svg';

const iconAndTextSize = {
    src: '/img/ufe/logo-apple-pay.svg',
    width: 42,
    height: 20
};

const applePayButtonStyle = {
    paddingLeft: 0,
    paddingRight: 0,
    border: 0
};

class ApplePayButton extends BaseClass {
    state = {};

    onClick = e => {
        e.stopPropagation();
        e.preventDefault();

        // 1-click checkout from the PDP
        if (this.props.isPdpFlow) {
            // PDP guard: parent blocks the flow (e.g. Auto-Replenish selected) before
            // any add-to-basket call is made.
            if (typeof this.props.onValidateClick === 'function' && !this.props.onValidateClick()) {
                // Auto-Replenish never adds to the basket, so there is
                // no add-to-basket confirmation to wait for
                pdpAnalytics.trackApplePayPdpButtonClick({
                    sku: this.props.sku,
                    basketType: this.props.fulfillmentType,
                    isAutoReplenish: this.props.isAutoReplenish,
                    errorMessage: this.props.autoReplenishErrorMessage
                });

                return;
            }

            ApplePay.onApplePayPdpClicked(this.props.sku, this.props.fulfillmentType, this.props.quantity);
        } else {
            //Analytics
            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    linkName: 'checkout:payment:applepay',
                    actionInfo: 'checkout:payment:applepay',
                    eventStrings: [anaConsts.Event.EVENT_71]
                }
            });

            ApplePay.onApplePayClicked(e);
        }
    };

    render() {
        const {
            isApplePayPayment, iconOnly = false, isPdpFlow, onValidateClick, isAutoReplenish, autoReplenishErrorMessage, ...props
        } = this.props;

        const isDisabled = isApplePayPayment === ApplePay.TYPES.DISABLED;

        const iconSize = iconOnly ? iconOnlySize : iconAndTextSize;
        // Gray logo ONLY for the disabled state inside the PDP 1-click flow. Every
        // other usage keeps its existing logo (iconOnlySize/iconAndTextSize).
        const shouldUseDisabledPdpLogo = isDisabled && isPdpFlow && iconOnly;
        const iconSrc = shouldUseDisabledPdpLogo ? iconOnlyDisabledSrc : iconSize.src;

        return isApplePayPayment !== ApplePay.TYPES.HIDDEN ? (
            <Button
                variant='primary'
                onClick={this.onClick}
                disabled={isDisabled}
                {...props}
                css={applePayButtonStyle}
            >
                <React.Fragment>
                    {iconOnly ? null : (
                        <Text
                            marginRight={2}
                            fontWeight='normal'
                        >
                            {getText('checkoutWith')}
                        </Text>
                    )}
                    <Image
                        disableLazyLoad={true}
                        alt='Apple Pay'
                        src={iconSrc}
                        width={iconSize.width}
                        height={iconSize.height}
                        maxHeight='100%'
                        css={{ objectFit: 'contain' }}
                    />
                </React.Fragment>
            </Button>
        ) : (
            <div></div>
        );
    }
}

export default wrapComponent(ApplePayButton, 'ApplePayButton', true);
